import React, { useState } from "react";
import { ActiveTab } from "../../types/activeTabs";
import { useCookies } from "react-cookie";

const ProfileHeader = ({ ProfileSetActiveTab }: { ProfileSetActiveTab: (tab: ActiveTab) => void }) => {
    const [activeTab, setActiveTab] = useState("الملف الشخصي"); // State to track active tab
    const [cookies, setCookie, removeCookie] = useCookies(['user-data', "token"]);
    // Get user role from cookies
    const userRole = cookies["user-data"].role;
    const isTrainer = userRole === "trainer";

    return (
        <div className="w-full bg-white shadow-sm">
            <div className="max-w-4xl mx-auto px-4">
                {/* Flex container with RTL direction */}
                <div className="flex flex-row-reverse space-x-4 space-x-reverse border-b border-gray-200">
                    {/* Tab 1: الملف الشخصي */}
                    <button
                        className={`py-4 relative text-lg font-medium ${activeTab === "الملف الشخصي"
                            ? "text-primary-500"
                            : "text-gray-500 hover:text-gray-700"
                            }`}
                        onClick={() => {
                            setActiveTab("الملف الشخصي");
                            ProfileSetActiveTab(ActiveTab.Profile);
                        }}
                    >
                        الملف الشخصي
                        {activeTab === "الملف الشخصي" && (
                            <span className="absolute bottom-0 left-0 w-full h-1 bg-primary-500"></span>
                        )}
                    </button>

                    {/* Conditionally Rendered Tabs */}
                    {isTrainer ? (
                        <button
                            className={`py-4 relative text-lg font-medium ${activeTab === "الايرادات"
                                ? "text-primary-500"
                                : "text-gray-500 hover:text-gray-700"
                                }`}
                            onClick={() => {
                                setActiveTab("الايرادات");
                                ProfileSetActiveTab(ActiveTab.Revenues);
                            }}
                        >
                            الايرادات
                            {activeTab === "الايرادات" && (
                                <span className="absolute bottom-0 left-0 w-full h-1 bg-primary-500"></span>
                            )}
                        </button>
                    ) : (
                        <button
                            className={`py-4 relative text-lg font-medium ${activeTab === "الدورات المسجلة"
                                ? "text-primary-500"
                                : "text-gray-500 hover:text-gray-700"
                                }`}
                            onClick={() => {
                                setActiveTab("الدورات المسجلة");
                                ProfileSetActiveTab(ActiveTab.EnrolledCourses);
                            }}
                        >
                            الدورات المسجلة
                            {activeTab === "الدورات المسجلة" && (
                                <span className="absolute bottom-0 left-0 w-full h-1 bg-primary-500"></span>
                            )}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProfileHeader;
